<template>
  <div class="balanceLog-container">
    <div class="balanceLog-top">
      <van-cell
        value="佣金明细"
        is-link
        :border="false"
        to="/pages/user/commissionDetail"
      >
        <template #title> </template>
      </van-cell>
    </div>
    <div class="mycommission">
      <van-icon name="gold-coin" class="gold-icon" />
      <span>我的佣金</span>
      <h1>{{ userInfo && userInfo.commission ? userInfo.commission : 0 }}</h1>
    </div>
    <div class="bank-card">
      <van-field
        readonly
        clickable
        name="picker"
        :value="bankNo"
        label="到账银行卡"
        placeholder="请选择银行卡"
        right-icon="arrow"
        @click="showPicker = true"
        :border="false"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="bankNo"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </div>
    <div class="count-box">
      <div>提现金额</div>
      <div class="commission-input">
        <h2>￥</h2>
        <van-field v-model="count" autofocus />
      </div>
    </div>
    <van-notice-bar
    v-if="userInfo.auto === 1"
      left-icon="volume-o"
      text="提现需收取0.01%的手续费。"
    />
    <van-button class="toTopUp selected fixedClass" @click="confirmClick">
      提现
    </van-button>
    <van-overlay :show="show">
      <div class="wrapper">
        <div class="block">
          <van-icon name="cross" class="cross-icon" @click="closeIcon" />
          <div class="inner-div">
            <div class="inner-title">请输入支付密码</div>
            <div class="inner-price">提现金额：{{ count }}元</div>
            <!-- 密码输入框 -->
            <van-password-input
              :value="value"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 数字键盘 -->
    <van-number-keyboard v-model="value" :show="showKeyboard" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Dialog } from 'vant'
export default {
  data() {
    return {
      columns: [],
      showPicker: false,
      value: "",
      bankNo: "",
      count: "",
      bankId: "",
      show: false,
      value: "",
      showKeyboard: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.loadData();
  },
  watch: {
    value(val) {
      if (val.length === 6) {
        this.checkPassword(val);
      }
    },
  },
  methods: {
    loadData() {
      this.$http.request(this.$http.pathMap.bankCardList, "get").then((res) => {
        res.data.forEach((item) => {
          console.log(item.bankNo.slice(-4));
          item.bankNo =
            item.bankType +
            "(" +
            item.bankNo.substring(item.bankNo.length - 4, item.bankNo.length) +
            ")";
        });
        this.columns = res.data;
        console.log(this.columns);
      });
    },
    checkPassword(value) {
      this.$http
        .request(this.$http.pathMap.checkPassword, "post", { password: value })
        .then((res) => {
          this.pwdPay();
        })
        .catch((err) => {
          this.value = "";
        });
    },
    confirmClick() {
      if (this.bankId === "") {
        return this.$toast("请选择银行卡");
      }
      if (this.count === "") {
        return this.$toast("请输入提现金额");
      }
      if (this.userInfo.isPwd === 0) {
        Dialog({
          title: "提示",
          message: "您未设置支付密码，请前往设置",
          confirmButtonText: "去设置",
        }).then(() => {
          this.$router.push("/pages/user/SetPassWord?set=1");
        });
        return;
      }
      this.show = true;
      this.showKeyboard = true;
    },
    pwdPay() {
      this.$http
        .request(this.$http.pathMap.withDrawSave, "post", {
          bankId: this.bankId,
          drawAmount: this.count,
        })
        .then((res) => {
          this.show = false;
          this.showKeyboard = false;
          this.$router.push("/pages/user/CommissionWithdrawal");
        });
    },
    onConfirm(value) {
      console.log(value);
      this.bankNo = value.bankNo;
      this.bankId = value.id;
      this.showPicker = false;
    },
    closeIcon() {
      (this.show = false), (this.showKeyboard = false);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  // align-items: center;
  margin-top: 140px;
  justify-content: center;
  height: 100%;
}
.block {
  width: 270px;
  height: 270px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  .cross-icon {
    position: absolute;
    left: 5px;
    top: 5px;
  }
  .inner-div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .inner-title {
      text-align: center;
      color: #000;
      margin-bottom: 10px;
    }
    .inner-price {
      text-align: center;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}
.van-cell {
  background: none;
  padding: 0;
  margin: 20px 0;
}
.moneny-number {
  font-size: 14px;
  color: $font-color-spec;
}
.balanceLog-container {
  padding: 15px;
  background: #f8f8f8;
  .mycommission {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .gold-icon {
      font-size: 40px;
      color: orange;
      margin-bottom: 20px;
    }
    h1 {
      margin-top: 5px;
    }
  }
  .count-box {
    .commission-input {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eee;
      ::v-deep .van-field__control {
        font-size: 35px;
      }
    }
  }
}
.toTopUp {
  margin-top: 20px;
  width: 100%;
  padding: 5px 0;
  text-align: center;
  border: none;
  background: none;
  border: 1px solid $uni-border-color;
  border-radius: 5px;
  color: #000;
  font-weight: 500;
}
.selected {
  background: $base-color;
  border: none;
  color: #fff;
}
.fixedClass {
  position: fixed;
  width: 370px !important;
  bottom: 10px;
  left: auto;
}
</style>
